// components/StepIndicator.jsx
import React from 'react';
import Icon from '../../../components/AppIcon';
import { STEPS } from '../../../data/constants';

const StepIndicator = ({ currentStep }) => {
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-4 sm:gap-8 justify-start sm:justify-center">
        {STEPS.map(step => (
          <div key={step.id} className="flex flex-col items-center shrink-0">
            <div
              className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border-2 ${
                currentStep >= step.id
                  ? 'bg-accent border-accent text-white'
                  : 'bg-white border-border text-gray-400'
              }`}
            >
              <Icon name={step.icon} size={18} />
            </div>
            <p className={`text-sm font-medium ${
              currentStep >= step.id ? 'text-accent' : 'text-white'
            }`}>
              Step {step.id}
            </p>
            <span className="mt-2 text-xs text-white text-center">
              {step.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;